'use client';

import { c as _c } from "react/compiler-runtime";
import { useDrawStatus } from '@svs/nova-poolbetting/core/frameworks/nextjs/draw';
import type { DrawNumber } from '@svs/nova-poolbetting/schema/draw';
import type { Definition } from '@svs/nova-poolbetting/schema/frameworks';
import { DrawCardStatusDesktop } from '@svs/nova-poolbetting/ui/DrawManager/client';
import type { ReactNode } from 'react';
type DrawCardStatusDesktopManagerProps = {
  drawNumber: DrawNumber;
  product: Definition['drawProducts'][number];
  isSelector?: boolean;
  isSelected?: boolean;
};

/**
 * Component for draw card status shown in draw card.
 *
 * @param root0 Component props
 * @param root0.drawNumber Draw number to load draw from
 * @param root0.product Product number to load draw from
 * @param root0.isSelector Whether the draw card is used as a selector
 * @param root0.isSelected Whether the draw card is selected in the selector
 * @returns component that renders the status for a draw
 */
export default function DrawCardStatusDesktopManager(t0) {
  const $ = _c(4);
  const {
    drawNumber,
    product,
    isSelector,
    isSelected
  } = t0;
  const status = useDrawStatus(drawNumber, product);
  let t1;
  if ($[0] !== isSelected || $[1] !== isSelector || $[2] !== status) {
    t1 = <DrawCardStatusDesktop status={status} isSelector={isSelector} isSelected={isSelected} />;
    $[0] = isSelected;
    $[1] = isSelector;
    $[2] = status;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}